/** Types that always render something (a box, a computed value, a stamp). */
const ALWAYS_SHOWN = new Set([
  "checkbox",
  "formula",
  "rollup",
  "created_time",
  "last_edited_time",
  "created_by",
  "last_edited_by",
  "button",
  "unique_id",
  "id",
]);

/** Mirrors what the property inputs show as "Empty" — used where a compact
 *  row needs to swap that placeholder for the property's own icon + name. */
export function isEmptyPropertyValue(type: string | undefined, value: unknown): boolean {
  if (type && ALWAYS_SHOWN.has(type)) return false;
  if (value == null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (typeof value === "number" || typeof value === "boolean") return false;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).every((v) => isEmptyPropertyValue(undefined, v));
  }
  return false;
}
